/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Catalog_Movement_Rear_DeltInputs */

const en_us2_catalog_movement_rear_delt = /** @type {(inputs: Catalog_Movement_Rear_DeltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rear delts`)
};

const pt_br2_catalog_movement_rear_delt = /** @type {(inputs: Catalog_Movement_Rear_DeltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`deltoide posterior`)
};

const es_419_catalog_movement_rear_delt = /** @type {(inputs: Catalog_Movement_Rear_DeltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`deltoides posterior`)
};

const pt_pt2_catalog_movement_rear_delt = /** @type {(inputs: Catalog_Movement_Rear_DeltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`deltoide posterior`)
};

const fr_fr2_catalog_movement_rear_delt = /** @type {(inputs: Catalog_Movement_Rear_DeltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`deltoïdes postérieurs`)
};

const de_de2_catalog_movement_rear_delt = /** @type {(inputs: Catalog_Movement_Rear_DeltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hintere Schulter`)
};

const it_it2_catalog_movement_rear_delt = /** @type {(inputs: Catalog_Movement_Rear_DeltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`deltoidi posteriori`)
};

/**
* | output |
* | --- |
* | "rear delts" |
*
* @param {Catalog_Movement_Rear_DeltInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const catalog_movement_rear_delt = /** @type {((inputs?: Catalog_Movement_Rear_DeltInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Catalog_Movement_Rear_DeltInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_catalog_movement_rear_delt(inputs)
	if (locale === "es-419") return es_419_catalog_movement_rear_delt(inputs)
	if (locale === "pt-PT") return pt_pt2_catalog_movement_rear_delt(inputs)
	if (locale === "fr-FR") return fr_fr2_catalog_movement_rear_delt(inputs)
	if (locale === "de-DE") return de_de2_catalog_movement_rear_delt(inputs)
	if (locale === "it-IT") return it_it2_catalog_movement_rear_delt(inputs)
	return en_us2_catalog_movement_rear_delt(inputs)
});
export { catalog_movement_rear_delt as "catalog.movement.rear_delt" }